module.exports = "<div fxLayout=\"row\" fxLayoutAlign=\"start center\">\n    <mat-icon>{{icon}}</mat-icon>\n    <span>{{type}}</span>  \n</div>\n"